import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { useCart } from '../contexts/CartContext'
import Currency from './Currency'
import { t } from '../utils/translations'
import { Eye } from 'lucide-react'
import './ProductCard.css'

const ProductCard = ({ product }) => {
  const { addToCart, loading } = useCart()
  const [isHovering, setIsHovering] = useState(false)

  const handleAddToCart = (e) => {
    e.preventDefault()
    addToCart(product.id, 1)
  }

  const displayPrice = product.sale_price || product.price
  const originalPrice = product.sale_price ? product.price : null
  const hasDiscount = product.sale_price && product.sale_price < product.price
  const discountPercent = hasDiscount ? Math.round((1 - product.sale_price / product.price) * 100) : 0

  return (
    <figure 
      className="product-card" 
      onMouseEnter={() => setIsHovering(true)}
      onMouseLeave={() => setIsHovering(false)}
    >
      <Link to={`/products/${product.id}`} className="product-card-link">
        <div className="product-card__image-wrapper">
          <img 
            src={product.images && product.images.length > 0 ? `/uploads/products/${product.images[0].filename}` : (product.featured_image ? `/uploads/products/${product.featured_image}` : 'https://via.placeholder.com/240x240?text=No+Image')} 
            alt={product.name}
            className="product-card_img"
          />
          
          {/* Quick View Button */}
          <div className="product-card__quick-actions">
            <div className="quick-view-btn" aria-label="Quick view">
              <Eye size={18} />
              <span>{t('view_details', 'عرض التفاصيل')}</span>
            </div>
          </div>

          {/* Featured Product Star */}
          {product.featured === 1 && (
            <div className="absolute top-2 right-2 bg-yellow-500 text-white text-xs px-2 py-1 rounded-full flex items-center">
              ⭐
            </div>
          )}

          {/* Discount Badge */}
          {hasDiscount && (
            <div className="product-card__badge">
              <span>-{discountPercent}%</span>
            </div>
          )}
        </div>
        
        <figcaption className="product-card_title">
          {product.name}
        </figcaption>
      </Link>
      
      <div className="price-cart">
        <div className="product-card_price">
          <Currency amount={displayPrice} />
          {originalPrice && (
            <span className="product-card_price_original">
              <Currency amount={originalPrice} />
            </span>
          )}
        </div>
        <button 
          className="product-card_btn" 
          title={t('add_to_cart', 'أضف للسلة')}
          onClick={handleAddToCart}
          disabled={loading || !product.in_stock}
          aria-label={t('add_to_cart', 'أضف للسلة')}
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="none" viewBox="0 0 24 24">
            <path fill="currentColor" d="M7 20a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm10 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4zM7.16 16l.94-2h7.8a2 2 0 0 0 1.92-1.45l2.54-7.63A1 1 0 0 0 19.4 4H6.21l-.94-2H1v2h2l3.6 7.59-1.35 2.44A2 2 0 0 0 5 17a2 2 0 0 0 2 2h12v-2H7.42a.25.25 0 0 1-.26-.19z"/>
          </svg>
        </button>
      </div>
      
      {/* Out of Stock Overlay */}
      {!product.in_stock && (
        <div className="product-card__out-of-stock">
          <span>{t('out_of_stock', 'نفد من المخزن')}</span>
        </div>
      )}
    </figure>
  )
}

export default ProductCard
